import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginService } from '../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../shared-modules/login/loginSetting.model';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { CourseTerm } from '../../../shared-components/student/course-term.model';
import { AssignmentService } from '../../assignment/assignment.service';
import { ReportCardGradesTerm } from '../grades.model';
import { UserService } from '../../../shared-components/user/user.service';

@Component({
    selector: 'app-comments-and-behavior-marks',
    templateUrl: './comments-and-behavior-marks.component.html',
    styleUrls: ['../grades.component.css']
})
export class CommentsAndBehaviorMarksComponent implements OnInit {

    gradeId: number;
    gradingTerm: string;
    gradingTermDescription: string;
    course = '';
    subjectSection = '';
    school = '';
    grade = '';
    comment = '';
    citizenship = '';
    citizenshipLabel = '';
    workhabits = '';
    standard: string;
    isGradeBookGrade: boolean;
    isStandardView: boolean;
    subjectCode: string;
    section: string;
    isTermSelected: boolean;
    courseName = '';
    teacherName = '';
    courseTerm: CourseTerm | string = '';
    gradeScale: string[] = [];
    studentSchedules: CourseSchedule[] = [];
    LoginSettings: LoginSettings;
    selectionIndex = -1;
    longDescription: string;
    termGrade: ReportCardGradesTerm;
    behaviorSkills: any[] = [];
    selectedCourse: CourseSchedule;
    behaviorLabel = 'Behavior';
    dialogTitle = 'Comments and Behavior Marks';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<CommentsAndBehaviorMarksComponent>,
        private router: Router,
        private loginService: LoginService,
        private assignmentService: AssignmentService,
        private userService: UserService
    ) { }

    // eslint-disable-next-line complexity
    ngOnInit() {
        this.LoginSettings = this.loginService.LoginSettings;
        this.gradeId = this.data.selectedGradeId;
        this.gradingTerm = this.data.selectedGradingTerm;
        this.gradingTermDescription = this.data.gradingTermDesc;
        this.standard = this.data.selectedStandard;
        this.isGradeBookGrade = this.data.isGradeBookGrade;
        this.isStandardView = this.data.selectedIsStandardView;
        this.subjectCode = this.data.selectedSubjectCode;
        this.section = this.data.selectedSection;
        this.isTermSelected = this.data.isTermSelected;
        this.selectedCourse = this.data.course;
        this.termGrade = this.data.termGrade;
        if (this.data.behaviorSocialSkillDescription != null) {
            this.behaviorLabel = this.data.behaviorSocialSkillDescription;
            this.dialogTitle = 'Comments and ' + this.data.behaviorSocialSkillDescription;
        }

        if (this.isStandardView) {
            if (this.selectedCourse.CourseTerms.filter(o => o.Id == this.termGrade.TermDefinitionId).length > 0) {
                this.longDescription = this.selectedCourse.CourseTerms.filter(o => o.Id == this.termGrade.TermDefinitionId)[0].LongDescription;
            }
        }

        this.gradeScale = [];
        if (this.data.gradingScale != null && this.data.gradingScale != '') {
            if (this.data.gradingScale.indexOf(',') > -1) {
                this.gradeScale = this.data.gradingScale.split(',');
            }
            else if (this.data.gradingScale.length > 0) {
                this.gradeScale.push(this.data.gradingScale);
            }
        }

        if (this.data.gradingTermDesc != null && this.data.gradingTermDesc != undefined && this.data.gradingTermDesc != '') {
            this.isGradeBookGrade = true;
        }

        this.studentSchedules = this.data.studentSchedules;
        for (let i = 0; i < this.studentSchedules.length; i++) {
            if (this.studentSchedules[i].Id == this.gradeId) {
                const ReportCardGrades = this.studentSchedules[i];
                this.course = ReportCardGrades.Course;
                this.subjectSection = ReportCardGrades.SubjectCode + '-' + ReportCardGrades.Section;
                this.school = ReportCardGrades.SchoolName;

                if (this.LoginSettings.ParentPortalAssignmentsDisplayProfiles) {
                    this.courseName = ReportCardGrades.Course + ' - ' + ReportCardGrades.Section;
                }
                else {
                    if (ReportCardGrades.Term == 'Year') {
                        this.courseName = ReportCardGrades.Course + ' - Yr';
                    }
                    else {
                        this.courseName = ReportCardGrades.Course + ' - ' + ReportCardGrades.Term;
                    }
                }
                this.teacherName = ReportCardGrades.TeacherName;
                if (ReportCardGrades.CourseTerms.length > 0) {
                    const _gradingTerm = this.data.selectedGradingTerm;
                    this.courseTerm = ReportCardGrades.CourseTerms.filter(function (el) { return el.ShortDescription = _gradingTerm; })[0];
                }

                if (this.data.selectedIsStandardView == false || this.isTermSelected == true) {
                    const ReportCardGradesDetails = this.studentSchedules[i].ReportCardGradesTerms;
                    for (let j = 0; j < ReportCardGradesDetails.length; j++) {
                        if (((ReportCardGradesDetails[j].Grade != '' || ReportCardGradesDetails[j].DisplayGrade != '') && ReportCardGradesDetails[j].GradingTerm != null) || (this.isTermSelected == true && ReportCardGradesDetails[j].GradingTerm != null)) {
                            if (ReportCardGradesDetails[j].GradingTerm == this.gradingTerm) {
                                this.grade = ReportCardGradesDetails[j].DisplayGrade;
                                if (ReportCardGradesDetails[j].Comment != null) {
                                    this.comment = ReportCardGradesDetails[j].Comment;
                                }
                                if (ReportCardGradesDetails[j].Citizenship != null) {
                                    this.citizenship = ReportCardGradesDetails[j].Citizenship;
                                }
                                if (ReportCardGradesDetails[j].CitizenshipLabel != null) {
                                    this.citizenshipLabel = ReportCardGradesDetails[j].CitizenshipLabel;
                                }
                                else {
                                    this.citizenshipLabel = 'Citizenship';
                                }
                                if (ReportCardGradesDetails[j].Workhabits != null) {
                                    this.workhabits = ReportCardGradesDetails[j].Workhabits;
                                    if (this.workhabits.length > 0) {
                                        this.behaviorSkills = this.workhabits.split(';');
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
                else {
                    for (let j = 0; j < this.studentSchedules[i].ReportCardGradesStandards.length; j++) {
                        const ReportCardGradesStandard = this.studentSchedules[i].ReportCardGradesStandards[j];
                        if (ReportCardGradesStandard != null) {
                            if (ReportCardGradesStandard.Id == this.data.id) {
                                const ReportCardGradesDetails = ReportCardGradesStandard.ReportCardGradesTerms;
                                if (ReportCardGradesDetails != null) {
                                    for (let k = 0; k < ReportCardGradesDetails.length; k++) {
                                        if (ReportCardGradesDetails[k].Grade != '' && ReportCardGradesDetails[k].GradingTerm != null) {
                                            if (ReportCardGradesDetails[k].GradingTerm == this.gradingTerm) {
                                                if (ReportCardGradesDetails[k].Grade != null && ReportCardGradesDetails[k].PercentGrade != null) {
                                                    this.grade = ReportCardGradesDetails[k].PercentGrade + '[' + ReportCardGradesDetails[k].Grade + ']';
                                                } else if (ReportCardGradesDetails[k].Grade != null) {
                                                    this.grade = ReportCardGradesDetails[k].Grade;
                                                } else if (ReportCardGradesDetails[k].PercentGrade != null) {
                                                    this.grade = ReportCardGradesDetails[k].PercentGrade;
                                                }
                                                const _gradingTerm = this.gradingTerm;
                                                const traditionalGrade = this.studentSchedules[i].ReportCardGradesTerms.filter(function (el) { return el.GradingTerm = _gradingTerm; })[0];
                                                if (traditionalGrade != null && traditionalGrade.Comment != null) {
                                                    this.comment = traditionalGrade.Comment;
                                                }
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    selectedView() {
        if (this.isStandardView == true && this.isTermSelected == false) {
            return false;
        }
        return true;
    }

    showStandard() {
        if (this.isStandardView == true && this.isTermSelected == false) {
            return true;
        }
        return false;
    }

    viewAssignment() {
        this.assignmentService.selectedCourse = this.selectedCourse;
        this.assignmentService.selectedSectionId = this.selectedCourse.SiteSectionId;
        this.assignmentService.selectedGP = this.gradingTerm;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/assignments');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/assignments');
        }

        this.dialogRef.close('Ok was clicked');
    }

    OkClick() {
        this.dialogRef.close('Ok was clicked');
    }

    closeClick() {
        this.dialogRef.close('Cancel was clicked.');
    }
}
